$(function() {
    const $appliancesWrapper = $('.appliances-wrapper');
    if ($appliancesWrapper.length === 0) return;

    // 支持 data-* 和普通属性
    const minPower = parseFloat($appliancesWrapper.data('min-power') || $appliancesWrapper.attr('min-power'));
    const maxPower = parseFloat($appliancesWrapper.data('max-power') || $appliancesWrapper.attr('max-power'));

    if (isNaN(minPower) || isNaN(maxPower)) return;

    const $applianceItems = $appliancesWrapper.find('.appliance-item');

    console.log('$applianceItems',$applianceItems);
    
    $applianceItems.each(function() {
        const ruleValue = parseFloat($(this).data('rule'));
        if (!isNaN(ruleValue)) {
            $(this).toggleClass('active', ruleValue <= minPower);
        }
    });

    const $radioButton = $('.ec-option-selector.checkbox-option-selector');
    const $qtyInput = $('input.quantity__input');

    if ($radioButton.length === 0 && $qtyInput.length === 0) return;

    function updateApplianceItems() {
        const qty = parseFloat($('input.quantity__input').val()) || 1;

        console.log('qty',qty);
        
        $applianceItems.each(function() {
            const ruleValue = parseFloat($(this).data('rule'));
            if (!isNaN(ruleValue) && minPower !== maxPower) {
                const $firstInput = $radioButton.find('input[type="radio"]').first();
                if ($firstInput.length && $firstInput.prop('checked')) {
                    $(this).toggleClass('active', ruleValue <= minPower * qty);
                } else {
                    $(this).toggleClass('active', ruleValue <= maxPower * qty);
                }
            } else {
                $(this).toggleClass('active', ruleValue <= maxPower * qty);
            }
        });
    }

    if ($radioButton.length) {
        $radioButton.on('change', function() {
            setTimeout(updateApplianceItems, 300);
        });
    }
    $(".product-information").on('change', 'input.quantity__input', function() {
        setTimeout(updateApplianceItems, 300);
    });


    

});
